const isServerless = () => typeof window !== "undefined";

export { isServerless };
